import React from 'react'

import { Tooltip, Avatar } from '@mantine/core'

import { getInitials } from 'src/lib/formatters'

export interface Avatar {
  firstName: string
  lastName: string
  isInactive?: boolean
}

interface AvatarGroupProps {
  avatars: Avatar[]
  threshold?: number
}

const AvatarGroup: React.FC<AvatarGroupProps> = ({
  avatars = [],
  threshold = 8,
}) => {
  // Sort avatars alphabetically by name
  const sortedAvatars = [...avatars].sort((a, b) =>
    `${a.firstName} ${a.lastName}`.localeCompare(`${b.firstName} ${b.lastName}`)
  )

  return (
    <Avatar.Group spacing="0">
      {sortedAvatars.slice(0, threshold).map((avatar, index) => (
        <Tooltip key={index} label={`${avatar.firstName} ${avatar.lastName}`}>
          <Avatar
            classNames={{
              placeholder: avatar.isInactive
                ? 'bg-doubleNickel-warning-100 text-doubleNickel-warning-600'
                : 'bg-doubleNickel-brand-25 text-doubleNickel-brand-500',
            }}
            size="sm"
            radius="sm"
          >
            {getInitials(`${avatar.firstName} ${avatar.lastName}`)}
          </Avatar>
        </Tooltip>
      ))}

      {sortedAvatars.length > threshold && (
        <Tooltip
          withArrow
          label={
            <>
              {sortedAvatars.slice(threshold).map((avatar, index) => (
                <div
                  key={index}
                >{`${avatar.firstName} ${avatar.lastName}`}</div>
              ))}
            </>
          }
        >
          <Avatar
            className="bg-doubleNickel-gray-100 text-doubleNickel-gray-700"
            size="sm"
            radius="sm"
          >
            +{sortedAvatars.length - threshold}
          </Avatar>
        </Tooltip>
      )}
    </Avatar.Group>
  )
}

export default AvatarGroup
